import React, { FC, useMemo } from 'react';
import PaginationPage from './PaginationPage';
import PaginationArrow from './PaginationArrow';
import ArrowsLine from '../assets/icons/ArrowsLine';
import { useSearchParams } from 'react-router';

type Props = {
  pages: number;
  url: string;
};

const Pagination: FC<Props> = ({ pages, url }) => {
  const [searchParams] = useSearchParams();
  const page = searchParams.get('page');
  const current = page ? +page : 1;

  const visiblePages = useMemo(() => {
    const totalButtons = 5;
    const result: number[] = [];

    if (pages <= totalButtons) {
      return Array.from({ length: pages }, (_, i) => i + 1);
    }

    let start = current - 2;
    let end = current + 2;

    if (start < 1) {
      end += 1 - start;
      start = 1;
    }
    if (end > pages) {
      start -= end - pages;
      end = pages;
    }

    for (let i = start; i <= end; i++) {
      result.push(i);
    }

    return result;
  }, [pages, current]);

  return (
    <nav aria-label='Pagination' className='flex w-full justify-center gap-3'>
      <PaginationArrow
        to={`/${url}?page=${current == 1 ? current : current - 1}`}
        disabled={current === 1}
      >
        <ArrowsLine color='currentColor' className='rotate-180' />
      </PaginationArrow>

      {visiblePages.map((page) => (
        <PaginationPage
          key={page}
          to={`/${url}?page=${page}`}
          active={current === page}
        >
          {page}
        </PaginationPage>
      ))}

      <PaginationArrow
        to={`/${url}?page=${current == pages ? current : current + 1}`}
        disabled={current === pages}
      >
        <ArrowsLine color='currentColor' />
      </PaginationArrow>
    </nav>
  );
};

export default Pagination;
